import { runActions } from "../action";
import { IDecorator, INmis } from "../types";
import { Decorator } from "./decorator";
import filterTool from "../util/filterTool";
import Nmis from "../nmis";

export class JsonEditDecorator extends Decorator implements IDecorator {
    public static NAME: string = "jsonEdit";

    // 

    /**
     * 获取当前对象实例
     * @returns 
     */
    getInstance() {
        return new JsonEditDecorator();
    }

    /**
     * 设置数据
     * @param data 
     */
    setData(data: any) {
        this.nmis!.$vue!.setData(data);        
    }

    /**
     * 获取数据
     */
    getData() {
        return this.nmis!.$vue!.getData();        
    }
}